var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.validBuildingParameters,
          expression: "validBuildingParameters"
        }
      ],
      ref: "building",
      staticClass: "building",
      style: { height: _vm.buildingHeight }
    },
    [
      _vm.actionType !== "view"
        ? _c("expand-building-button", {
            staticClass: "add-floor-button",
            on: {
              click: function($event) {
                return _vm.$emit("add-ground-floor")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("roof", { attrs: { "roof-width": _vm.roofWidth } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: { display: "flex", "flex-direction": "row" },
          style: { "margin-left": _vm.actionType !== "view" ? "0px" : "36px" }
        },
        [
          _vm.actionType !== "view"
            ? _c("expand-building-button", {
                staticStyle: { transform: "rotate(270deg)" },
                style: { top: _vm.addColumnButtonPosition },
                on: { click: _vm.addColumn }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "floorbox-columns" },
            _vm._l(_vm.columns, function(column) {
              return _c(
                "div",
                {
                  key: column.color,
                  staticClass: "floorbox-column",
                  style: {
                    height: _vm.columnHeight + "px",
                    backgroundColor:
                      _vm.selectedObjectIsColumn &&
                      _vm.selectedObject.index === column.index
                        ? "#9f9f9f"
                        : "#8a8a8a"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("select-column", column.index)
                    }
                  }
                },
                [
                  _vm._l(
                    column.floorboxes.length > 3
                      ? column.floorboxes.slice(0, 2)
                      : column.floorboxes,
                    function(floorbox, fbIndex) {
                      return _c("div", {
                        key: floorbox.color,
                        staticClass: "floorbox",
                        style: {
                          backgroundColor: floorbox.color,
                          border:
                            _vm.selectedFloorbox.label === floorbox.label
                              ? "1px red solid"
                              : "none"
                        },
                        attrs: { id: "col-" + column.index + "-fb-" + fbIndex },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.selectFloorbox(floorbox, column.index)
                          }
                        }
                      })
                    }
                  ),
                  _vm._v(" "),
                  column.floorboxes.length > 3
                    ? _c("div", { staticClass: "floorbox ellipsis" }, [
                        _c("span", [_vm._v("...")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "floorbox-tooltip",
                            style: {
                              "margin-left":
                                -(8 * column.floorboxes.length - 4) + "px"
                            }
                          },
                          _vm._l(column.floorboxes, function(
                            floorbox,
                            floorboxIndex
                          ) {
                            return _c("div", {
                              key: floorbox.color,
                              staticClass: "floorbox",
                              style: { "background-color": floorbox.color },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.$emit("swap-floorbox", {
                                    columnIndex: column.index,
                                    floorboxIndex: floorboxIndex
                                  })
                                }
                              }
                            })
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticClass: "upper-building" },
              _vm._l(_vm.groundFloors, function(floor, floorIndex) {
                return _c(
                  "div",
                  {
                    key: floorIndex,
                    staticClass: "building-floor",
                    style: {
                      filter:
                        _vm.selectedObjectIsFloor &&
                        floorIndex === _vm.selectedObject.index
                          ? "brightness(0.7)"
                          : "brightness(1)",
                      width: _vm.floorWidth + "px"
                    },
                    attrs: {
                      id:
                        "g-floor-" + (_vm.groundFloors.length - 1 - floorIndex)
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectFloor(floorIndex, "g")
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "fraction-container" },
                      _vm._l(
                        floor.fractions.length > 4
                          ? floor.fractions.slice(0, 4)
                          : floor.fractions,
                        function(fraction, fractionIndex) {
                          return _c("div", { key: fractionIndex }, [
                            _c(
                              "div",
                              {
                                staticClass: "fraction",
                                attrs: {
                                  id:
                                    "g-floor-" +
                                    (_vm.groundFloors.length - 1 - floorIndex) +
                                    "-fraction-" +
                                    fraction
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.$emit("select-fraction", {
                                      floorIndex: floorIndex,
                                      floorType: "g",
                                      fractionIndex: fractionIndex
                                    })
                                  }
                                }
                              },
                              [
                                floor.fractions.length > 4 &&
                                fractionIndex === 3
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                  +" +
                                          _vm._s(floor.fractions.length - 3) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "fraction-floorbox",
                              style: { background: fraction.floorbox_color }
                            })
                          ])
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c("building-side", {
                      key: _vm.selectedFloorbox.uuid,
                      attrs: {
                        "is-building-entrance-floor": floorIndex === 0,
                        "selected-floorbox": _vm.selectedFloorbox
                      },
                      on: {
                        click: function($event) {
                          return _vm.connectAllFractions(floorIndex, "g")
                        }
                      }
                    })
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "lower-building" },
              _vm._l(_vm.undergroundFloors, function(floor, floorIndex) {
                return _c(
                  "div",
                  {
                    key: floorIndex,
                    staticClass: "building-floor",
                    style: {
                      filter:
                        _vm.selectedObjectIsFloor &&
                        -floorIndex - 1 === _vm.selectedObject.index
                          ? "brightness(0.7)"
                          : "brightness(1)",
                      width: _vm.floorWidth + "px"
                    },
                    attrs: { id: "u-floor-" + floorIndex },
                    on: {
                      click: function($event) {
                        return _vm.selectFloor(floorIndex, "u")
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "fraction-container" },
                      _vm._l(
                        floor.fractions.length > 4
                          ? floor.fractions.slice(0, 4)
                          : floor.fractions,
                        function(fraction, fractionIndex) {
                          return _c("div", { key: fractionIndex }, [
                            _c(
                              "div",
                              {
                                staticClass: "fraction",
                                attrs: {
                                  id:
                                    "u-floor-" +
                                    floorIndex +
                                    "-fraction-" +
                                    fraction
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.$emit("select-fraction", {
                                      floorIndex: floorIndex,
                                      floorType: "u",
                                      fractionIndex: fractionIndex
                                    })
                                  }
                                }
                              },
                              [
                                floor.fractions.length > 4 &&
                                fractionIndex === 3
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                  +" +
                                          _vm._s(floor.fractions.length - 3) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "fraction-floorbox",
                              style: { background: fraction.floorbox_color }
                            })
                          ])
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c("building-side", {
                      key: _vm.selectedFloorbox.uuid,
                      attrs: { "selected-floorbox": _vm.selectedFloorbox },
                      on: {
                        click: function($event) {
                          return _vm.connectAllFractions(floorIndex, "u")
                        }
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.actionType !== "view"
        ? _c("expand-building-button", {
            staticClass: "add-floor-button",
            staticStyle: { transform: "rotate(180deg)" },
            on: {
              click: function($event) {
                return _vm.$emit("add-underground-floor")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "ground-divider",
        style: {
          "margin-top": _vm.floorPosition,
          width: _vm.groundWidth + "px"
        }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "ground",
        style: {
          width: _vm.groundWidth + "px",
          height: _vm.groundHeight + "px"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67d567d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67d567d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/Building.vue
// module id = null
// module chunks = 